import { useLocation, Outlet, Navigate } from 'react-router-dom'
import useAuth from './../hooks/useAuth'

// const allowedRole = ['USER', 'ADMIN', 'PRODUCER', 'PUBLISHER']

const RequirdAuth = ({ allowedRole }) => {
  const { auth } = useAuth()
  const location = useLocation()

  return auth?.role?.find(role => allowedRole?.includes(role)) ? (
    <Outlet />
  ) : auth?.user ? (
    <Navigate to={'/unauthorzied'} state={{ from: location }} replace />
  ) : (
    <Navigate to={'/login'} state={{ from: location }} replace />
  )
}

export default RequirdAuth
